export default "__VITE_ASSET__BOQZ4zon__"